import React from 'react';
import Enrollment from '../enrollment/Enrollment';

export const RegisterPage = () => {
  return <Enrollment />;
};

